// src/components/Testimonials.jsx
import React, { useRef, useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const reviews = [
  {
    name: "Brittany Cavicchioni",
    title: "Local Guide",
    reviewCount: "55 reviews",
    photoCount: "13 photos",
    rating: 5,
    timeAgo: "a month ago",
    content: "The staff and treatment modalities at Redemption Psychiatry are truly fantastic. Every time I receive care here, I feel safe, supported, and genuinely understood. Their approach to ketamine therapy, psychotherapy, and medication management is both effective and compassionate. Melinda Healy is an incredible patient advocate and has a true passion for helping first responders (I am not one). I'm deeply grateful for her care, insight, and dedication."
  },
  {
    name: "Mellonie B",
    title: "",
    reviewCount: "5 reviews",
    photoCount: "",
    rating: 5,
    timeAgo: "3 weeks ago",
    content: "Zack in the TMS is amazing. He has been a great in administering my treatment and explaining the process and concern for my comfort. Jess at the front desk has gone above and beyond to help me with my questions and needs. Everyone has been wonderful"
  },
  {
    name: "Taylor Campbell",
    title: "",
    reviewCount: "4 reviews",
    photoCount: "1 photo",
    rating: 5,
    timeAgo: "4 months ago",
    content: "Redemption has given me a whole new take on life. I was diagnosed with Clinical Depression in 2020, words could not describe the anxiety, emptiness, sadness & helplessness this would bring to my life for the first time in 28 years. I was referred to Landis by my Therapist & he was able to diagnose me with Treatment Resistant Depression right away after my PCP had put me on every antidepressant & anxiety med on the market that just did not work for me. He got me into TMS right away and a few weeks later I started the Infusions in addition to this treatment. I can not put into words how this series was able to help my brain chemistry as well as teach me to retrain my brain to over come the anxiety I've suffered for years. I am so grateful for what Redemption has given me and the fresh start on life I never thought I'd have. Thank you for all you guys do! ❤"
  },
  {
    name: "Jordan Erickson",
    title: "Local Guide",
    reviewCount: "20 reviews",
    photoCount: "9 photos",
    rating: 5,
    timeAgo: "3 months ago",
    content: "I've recently started TMS at Redemption and I can't speak highly enough about all of the staff - from the front desk, to Dr. Sethi, and most importantly Raquelle & Zach, the two TMS techs that I've been so lucky to have my sessions with. Both of them are SO knowledgeable and willing to answer any questions about the process, the results, the reasons behind the process, etc etc etc. I spend my entire session asking questions and if they don't know the answers, they email the doctors and we get an almost immediate response. It's been so helpful and reassuring as TMS is something I wasn't very familiar with, prior to starting treatment. So to have these two as resources has been invaluable. Raquelle is the problem solver of the universe and anytime I bring up a question or possible concern, she provides me a solution immediately. Given how little my brain is functioning at the moment, due to severe depression, it's a literal lifesaver to have people so willing and able to help, as well as solve problems and provide resources. Thank you to everyone who's been involved in my care, you have no idea how critical you've been in saving my life. Also, shout out to Allie, Maddy, and Brandon with the Ketamine team. They have listened to me cry and been pivotal in navigating a true mental health crisis with me, ensuring I had all of the care I needed. Everyone has truly gone above and beyond. Thank you from the bottom of my heart!"
  },
  {
    name: "Rebecca Morgan-Wetzel",
    title: "Local Guide",
    reviewCount: "11 reviews",
    photoCount: "34 photos",
    rating: 5,
    timeAgo: "a year ago",
    content: "The team at the Mesa location go above and beyond for their patients. Dr Friday is caring and a superior doctor. Roger and Stephanie H provides a safe and comfortable environment. Stephanie the intake coordinator for TMS is smart and helpful. So, is the Ketamine coordinator. I did 36 treatments of TMS, Justin, Jesse, Hailey all excellent technicians. I felt like I was an employee there going everyday. The front staff at check in are welcoming and warm employees who makes you feel at home. If I could give you 10 ⭐'s I would! Look forward to continue my mental health journey with this clinic."
  },
  {
    name: "Jonathan Voyce",
    title: "",
    reviewCount: "1 review",
    photoCount: "",
    rating: 5,
    timeAgo: "2 months ago",
    content: "Roger Mayorga worked with me and developed a treatment plan that has proven to be extremely effective. My experiences with he and Redemption Psychiatry have positively impacted my life."
  },
  {
    name: "Julia Bentley",
    title: "",
    reviewCount: "9 reviews",
    photoCount: "",
    rating: 5,
    timeAgo: "6 months ago",
    content: "I've had 5 TMS sessions so far and can definitely feel a difference. I'm more relaxed, less irritatable and just generally happier. My mood has improved and i can really see a difference in my relationships. My techs, Zach and Raquel has been wonderful. Very kind, patient and informative. I look forward to completing my entire course of treatment."
  }
];

const Testimonials = () => {
  const swiperRef = useRef(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div id="home-quotes-container" className="container-fluid">
      <div id="quotes" className="container" style={{ position: 'relative', overflow: 'visible' }}>
        {isDesktop && (
          <>
            <button 
              className="testimonials-nav prev" 
              onClick={() => swiperRef.current?.slidePrev()}
              style={{
                position: 'absolute',
                left: '-80px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: '#3a66bd',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                fontSize: '24px',
                fontWeight: 'bold',
                cursor: 'pointer',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#2951a3';
                e.target.style.transform = 'translateY(-50%) scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#3a66bd';
                e.target.style.transform = 'translateY(-50%) scale(1)';
              }}
            >
              ‹
            </button>
            <button 
              className="testimonials-nav next" 
              onClick={() => swiperRef.current?.slideNext()}
              style={{
                position: 'absolute',
                right: '-80px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: '#3a66bd',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                fontSize: '24px',
                fontWeight: 'bold',
                cursor: 'pointer',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#2951a3';
                e.target.style.transform = 'translateY(-50%) scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#3a66bd';
                e.target.style.transform = 'translateY(-50%) scale(1)';
              }}
            >
              ›
            </button>
          </>
        )}
        
        <Swiper
          onSwiper={(swiper) => { swiperRef.current = swiper; }}
          modules={[Pagination, Navigation, Autoplay]}
          loop={true}
          speed={1000}
          autoHeight={true}
          slidesPerView={3}
          spaceBetween={20}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true, el: '#quotes-pagination' }}
          breakpoints={{
            1200: { slidesPerView: 3 },
            850: { slidesPerView: 2 },
            0: { slidesPerView: 1 }
          }}
        >
          {reviews.map((review, idx) => (
            <SwiperSlide key={idx}>
              <div className="swiper-slide-inner">
                <img src="/img/icon-quote.svg" alt="Quote" />
                <p>{review.content}</p>
                <div className="review-footer">
                  <div>
                    <p className="name">{review.name}</p>
                    {review.title && <span className="reviewer-title">{review.title}</span>}
                    {review.timeAgo && <span className="time-ago"> • {review.timeAgo}</span>}
                  </div>
                  <div className="star-rating">
                    {[...Array(review.rating)].map((_, i) => (
                      <LazyLoadImage key={i} alt="Star" effect="blur" src="/img/icon-star.svg"/>
                    ))}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div id="quotes-pagination"></div>
    </div>
  );
};

export default Testimonials;
